import * as React from 'react';
import { PaymentMethodType, WebGivingPaymentMethodModel } from '../../webgiving-generated';
import { SvgIcon, SvgProperties } from '../svg-icon';
import { paymentMethodAriaLabel } from '../../utils/aria';
import { panelContentTransitionDuration } from '../panel-content-transition';
import { Text } from '../../components/text';

/* assets */
import * as styles from './payment-method-selector.less';
import cardIcon from '../../assets/svg/card.svg';
import tickIcon from '../../assets/svg/icon-tick.svg';
import cardBrandIcons from '../card-brand-icons';


interface IPaymentMethodProps {
	paymentMethod: WebGivingPaymentMethodModel;
	checked: boolean;
	name: string;
	onChange: Function;
	id: string;
	failed: boolean;
	ariaDescribedBy?: string;
}

export class PaymentMethod extends React.Component<IPaymentMethodProps, {}> {
	private input: HTMLInputElement;
	private focusTimeout: number;

	render() {
		const {
			paymentMethod,
			name,
			checked,
			failed,
			id,
			ariaDescribedBy,
		} = this.props;
		const brandIcon = getBrandIconInfo(paymentMethod.BrandSvgLogo);

		const selectedIcon = <SvgIcon svg={tickIcon} className={styles.selectedIcon} />;
		const unselectedIcon = <SvgIcon svg={tickIcon} className={styles.unselectedIcon} />;

		let expiryDate = null;
		if (paymentMethod.PaymentMethodType === PaymentMethodType.CreditCard) {
			expiryDate = <div className={styles.expiryDate}><Text>Expiry</Text>: {paymentMethod.CardExpiryMonth}/{paymentMethod.CardExpiryYear}</div>;
		}

		const cardDisplayName = paymentMethod.Nickname || paymentMethod.BrandDisplayName;

		return (
			<div className={`col-sm-6 ${styles.method}`}>
				<input
					className={styles.radio}
					type="radio"
					name={name}
					checked={checked}
					onChange={this.handleChange}
					ref={this.saveInput}
					id={id}
				/>
				<label
					className={styles.label}
					data-pp-at-target={id}
					aria-invalid={failed}
					aria-describedby={ariaDescribedBy}
					aria-label={paymentMethodAriaLabel(paymentMethod)}
					htmlFor={id}
				>
					<div className={`${styles.selector} ${checked ? styles.isActive : ''} ${failed ? styles.failed : ''}`}>
						<div className={styles.row}>
							<div className={styles.columnLeft}>
								<div className={styles.description} title={cardDisplayName}>{cardDisplayName}</div>
								<div className={styles.cardNumber}>{paymentMethod.DisplayReference}</div>
								{expiryDate}
							</div>
							<div className={styles.columnRight}>
								<div className={styles.columnRightTop}>
									{ checked ? selectedIcon : unselectedIcon }
								</div>
								<div className={styles.columnRightBottom}>
									<SvgIcon svg={brandIcon} className={styles.brandIcon} />
								</div>
							</div>
						</div>
					</div>
				</label>
			</div>
		);
	}

	componentDidMount() {
		const { props: { checked }, input } = this;

		if (checked && input) {
			this.focusTimeout = window.setTimeout(this.focusInput, panelContentTransitionDuration);
		}
	}

	componentWillUnmount() {
		window.clearTimeout(this.focusTimeout);
	}

	handleChange = () => {
		this.props.onChange(this.props.paymentMethod);
	}

	private saveInput = (input: HTMLInputElement) => this.input = input;

	private focusInput = () => {
		this.input.focus();
	}
}

const bankCardBrands = ['checking', 'savings'];

function getBrandIconInfo(cardBrand: string): SvgProperties {
	let svg:SvgProperties = cardIcon;
	if (bankCardBrands.indexOf(cardBrand) !== -1) {
		cardBrand = 'bank';
	}
	if (cardBrand) {
		const [iconKey] = cardBrandIcons.keys().filter(x => x.toLowerCase().indexOf(`paymentmethod-${cardBrand.toLowerCase()}.svg`) !== -1);

		if (iconKey) {
			svg = (cardBrandIcons(iconKey) as any).default as SvgProperties;
		}
	}
	return svg;
}
